// @flow
import JQueryView, { on } from '../common/JQueryView';
import PdfDialog from '../editors/PdfDialog';
import SummernoteClient from '../../models/summernotes/SummernoteClient';

declare var $: any;

export default class FormView extends JQueryView {
  image: any;
  presidentImage: any;
  movie: string;
  stamp: any;
  summernoteClient = new SummernoteClient();
  pdfDialog = new PdfDialog();

  constructor(
    image: string,
    presidentImage: string,
    movie: string,
    stamp: string,
  ) {
    super('.simple_form');

    this.image = image;
    this.presidentImage = presidentImage;
    this.movie = movie;
    this.stamp = stamp;

    $('.form_date').datetimepicker({
      locale: 'ja',
      format: 'YYYY/MM/DD',
      sideBySide: true,
    });

    $('.form_datetime').datetimepicker({
      locale: 'ja',
      format: 'YYYY/MM/DD HH:mm',
      sideBySide: true,
    });

    this.setUpStockholderManagement();
    this.setUpDescription();
    this.setUpCompanyInfo();
    this.setUpSolicitInfo();
    this.setUpRiskInfo();
    this.setUpFinancialInfo();
    this.setUpReviewResult();
    this.setUpRiskSummery();
    this.setUpHowToUse();
    this.setUpFinanceCondition();
    this.setUpBusinessPlanValidity();
    this.setUpGovernanceSystem();
    this.render();
  }

  buildPdfButton(id: string, summernote: any) {
    const button = $.summernote.ui.button({
      contents: '<i class="far fa-file-pdf" style="padding-top: 4px"/>',
      tooltip: 'PDFリンクを貼り付け',
      click: () => {
        // $FlowFixMe
        this.pdfDialog.showDialog(id, summernote);
      },
    });
    return button.render();
  }

  setUpStockholderManagement() {
    const note = $('#project_draft_stockholder_management').summernote({
      height: 240,
      lang: 'ja-JP',
      callbacks: {
        onImageUpload: files => {
          this.summernoteClient
            .create(files[0])
            .then(response => {
              note.summernote('insertImage', response.data.url);
            })
            .catch(error => {
              alert(error);
            });
        },
      },
    });
  }

  setUpDescription() {
    const note = $('#project_draft_description').summernote({
      height: 480,
      lang: 'ja-JP',
      toolbar: [
        ['style', ['style']],
        ['font', ['bold', 'underline', 'clear']],
        ['fontname', ['fontname']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['table', ['table']],
        ['insert', ['link', 'picture', 'video', 'pdf']],
        ['view', ['fullscreen', 'codeview', 'help']],
      ],
      // buttons: {
      //   pdf: () => this.buildPdfButton('#project_draft_description', note),
      // },
      callbacks: {
        onImageUpload: files => {
          this.summernoteClient
            .create(files[0])
            .then(response => {
              note.summernote('insertImage', response.data.url);
            })
            .catch(error => {
              alert(error);
            });
        },
      },
    });
  }

  setUpCompanyInfo() {
    const note = $('#project_draft_company_info').summernote({
      height: 480,
      lang: 'ja-JP',
      toolbar: [
        ['style', ['style']],
        ['font', ['bold', 'underline', 'clear']],
        ['fontname', ['fontname']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['table', ['table']],
        ['insert', ['link', 'picture', 'video', 'pdf']],
        ['view', ['fullscreen', 'codeview', 'help']],
      ],
      // buttons: {
      //   pdf: () => this.buildPdfButton('#project_draft_company_info', note),
      // },
      callbacks: {
        onImageUpload: files => {
          this.summernoteClient
            .create(files[0])
            .then(response => {
              note.summernote('insertImage', response.data.url);
            })
            .catch(error => {
              alert(error);
            });
        },
      },
    });
  }

  setUpSolicitInfo() {
    const note = $('#project_draft_solicit_info').summernote({
      height: 480,
      lang: 'ja-JP',
      toolbar: [
        ['style', ['style']],
        ['font', ['bold', 'underline', 'clear']],
        ['fontname', ['fontname']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['table', ['table']],
        ['insert', ['link', 'picture', 'video', 'pdf']],
        ['view', ['fullscreen', 'codeview', 'help']],
      ],
      // buttons: {
      //   pdf: () => this.buildPdfButton('#project_draft_solicit_info', note),
      // },
      callbacks: {
        onImageUpload: files => {
          this.summernoteClient
            .create(files[0])
            .then(response => {
              note.summernote('insertImage', response.data.url);
            })
            .catch(error => {
              alert(error);
            });
        },
      },
    });
  }

  setUpRiskInfo() {
    const note = $('#project_draft_risk_info').summernote({
      height: 480,
      lang: 'ja-JP',
      toolbar: [
        ['style', ['style']],
        ['font', ['bold', 'underline', 'clear']],
        ['fontname', ['fontname']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['table', ['table']],
        ['insert', ['link', 'picture', 'video', 'pdf']],
        ['view', ['fullscreen', 'codeview', 'help']],
      ],
      // buttons: {
      //   pdf: () => this.buildPdfButton('#project_draft_risk_info', note),
      // },
      callbacks: {
        onImageUpload: files => {
          this.summernoteClient
            .create(files[0])
            .then(response => {
              note.summernote('insertImage', response.data.url);
            })
            .catch(error => {
              alert(error);
            });
        },
      },
    });
  }

  setUpFinancialInfo() {
    const note = $('#project_draft_financial_info').summernote({
      height: 480,
      lang: 'ja-JP',
      toolbar: [
        ['style', ['style']],
        ['font', ['bold', 'underline', 'clear']],
        ['fontname', ['fontname']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['table', ['table']],
        ['insert', ['link', 'picture', 'video', 'pdf']],
        ['view', ['fullscreen', 'codeview', 'help']],
      ],
      // buttons: {
      //   pdf: () => this.buildPdfButton('#project_draft_financial_info', note),
      // },
      callbacks: {
        onImageUpload: files => {
          this.summernoteClient
            .create(files[0])
            .then(response => {
              note.summernote('insertImage', response.data.url);
            })
            .catch(error => {
              alert(error);
            });
        },
      },
    });
  }

  setUpReviewResult() {
    const note = $('#project_draft_review_result').summernote({
      height: 480,
      lang: 'ja-JP',
      toolbar: [
        ['style', ['style']],
        ['font', ['bold', 'underline', 'clear']],
        ['fontname', ['fontname']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['table', ['table']],
        ['insert', ['link', 'picture', 'video', 'pdf']],
        ['view', ['fullscreen', 'codeview', 'help']],
      ],
      // buttons: {
      //   pdf: () => this.buildPdfButton('#project_draft_review_result', note),
      // },
      callbacks: {
        onImageUpload: files => {
          this.summernoteClient
            .create(files[0])
            .then(response => {
              note.summernote('insertImage', response.data.url);
            })
            .catch(error => {
              alert(error);
            });
        },
      },
    });
  }

  setUpRiskSummery() {
    $('#project_draft_risk_summery').summernote({
      height: 240,
      lang: 'ja-JP',
      toolbar: [
        ['style', ['style']],
        ['font', ['bold', 'underline', 'clear']],
        ['fontname', ['fontname']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['table', ['table']],
        ['view', ['fullscreen', 'codeview', 'help']],
      ],
    });
  }

  setUpHowToUse() {
    $('#project_draft_how_to_use').summernote({
      height: 240,
      lang: 'ja-JP',
      toolbar: [
        ['style', ['style']],
        ['font', ['bold', 'underline', 'clear']],
        ['fontname', ['fontname']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['table', ['table']],
        ['view', ['fullscreen', 'codeview', 'help']],
      ],
    });
  }

  setUpFinanceCondition() {
    $('#project_draft_finance_condition').summernote({
      height: 240,
      lang: 'ja-JP',
      toolbar: [
        ['style', ['style']],
        ['font', ['bold', 'underline', 'clear']],
        ['fontname', ['fontname']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['table', ['table']],
        ['view', ['fullscreen', 'codeview', 'help']],
      ],
    });
  }

  setUpBusinessPlanValidity() {
    $('#project_draft_business_plan_validity').summernote({
      height: 240,
      lang: 'ja-JP',
      toolbar: [
        ['style', ['style']],
        ['font', ['bold', 'underline', 'clear']],
        ['fontname', ['fontname']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['table', ['table']],
        ['view', ['fullscreen', 'codeview', 'help']],
      ],
    });
  }

  setUpGovernanceSystem() {
    $('#project_draft_governance_system').summernote({
      height: 240,
      lang: 'ja-JP',
      toolbar: [
        ['style', ['style']],
        ['font', ['bold', 'underline', 'clear']],
        ['fontname', ['fontname']],
        ['color', ['color']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['table', ['table']],
        ['view', ['fullscreen', 'codeview', 'help']],
      ],
    });
  }

  @on('change #project_draft_image')
  onChangeImage(event: any) {
    if (
      event.target instanceof HTMLInputElement &&
      event.target.files.length > 0
    ) {
      const fr = new FileReader();

      fr.onload = () => {
        this.image = fr.result;
        this.render();
      };
      fr.readAsDataURL($(event.target).prop('files')[0]);
    }
  }

  @on('change #project_draft_president_image')
  onChangePresidentImage(event: any) {
    if (
      event.target instanceof HTMLInputElement &&
      event.target.files.length > 0
    ) {
      const fr = new FileReader();

      fr.onload = () => {
        this.presidentImage = fr.result;
        this.render();
      };
      fr.readAsDataURL($(event.target).prop('files')[0]);
    }
  }

  @on('change #project_draft_stamp')
  onChangeStamp(event: any) {
    if (
      event.target instanceof HTMLInputElement &&
      event.target.files.length > 0
    ) {
      const fr = new FileReader();

      fr.onload = () => {
        this.stamp = fr.result;
        this.render();
      };
      fr.readAsDataURL($(event.target).prop('files')[0]);
    }
  }

  @on('change input[name="project_draft[stock_type]"]:radio')
  onChengeStockType() {
    this.render();
  }

  @on('keyup #project_draft_interview_movie')
  onChangeInterviewMovie() {
    this.movie = $('#project_draft_interview_movie').val();
    this.render();
  }

  @on('change input[name="project_draft[angel_type]"]:radio')
  onChangeAngelType() {
    this.render();
  }

  @on('change input[name="project_draft[contract_before_type]"]:radio')
  onChangeContractBeforeType() {
    this.render();
  }

  @on('click .remove_fields')
  onClickRemoveFields(event: any) {
    $(event.target)
      .prev('input[type=hidden]')
      .val('1');
    $(event.target)
      .closest('fieldset')
      .hide();
    event.preventDefault();
  }

  @on('click .add_fields')
  onClickAddFields(event: any) {
    const time = new Date().getTime();
    const regexp = new RegExp($(event.target).data('id'), 'g');
    $(event.target).before(
      $(event.target)
        .data('fields')
        .replace(regexp, time),
    );
    event.preventDefault();
  }

  @on('submit')
  onSubmit() {
    if (
      $('#project_draft_stockholder_management').summernote(
        'codeview.isActivated',
      )
    ) {
      $('#project_draft_stockholder_management').summernote(
        'codeview.deactivate',
      );
    }

    if ($('#project_draft_description').summernote('codeview.isActivated')) {
      $('#project_draft_description').summernote('codeview.deactivate');
    }

    if ($('#project_draft_company_info').summernote('codeview.isActivated')) {
      $('#project_draft_company_info').summernote('codeview.deactivate');
    }

    if ($('#project_draft_solicit_info').summernote('codeview.isActivated')) {
      $('#project_draft_solicit_info').summernote('codeview.deactivate');
    }

    if ($('#project_draft_risk_info').summernote('codeview.isActivated')) {
      $('#project_draft_risk_info').summernote('codeview.deactivate');
    }

    if ($('#project_draft_financial_info').summernote('codeview.isActivated')) {
      $('#project_draft_financial_info').summernote('codeview.deactivate');
    }

    if ($('#project_draft_review_result').summernote('codeview.isActivated')) {
      $('#project_draft_review_result').summernote('codeview.deactivate');
    }

    if ($('#project_draft_risk_summery').summernote('codeview.isActivated')) {
      $('#project_draft_risk_summery').summernote('codeview.deactivate');
    }

    if ($('#project_draft_how_to_use').summernote('codeview.isActivated')) {
      $('#project_draft_how_to_use').summernote('codeview.deactivate');
    }

    if (
      $('#project_draft_finance_condition').summernote('codeview.isActivated')
    ) {
      $('#project_draft_finance_condition').summernote('codeview.deactivate');
    }

    if (
      $('#project_draft_business_plan_validity').summernote(
        'codeview.isActivated',
      )
    ) {
      $('#project_draft_business_plan_validity').summernote(
        'codeview.deactivate',
      );
    }

    if (
      $('#project_draft_governance_system').summernote('codeview.isActivated')
    ) {
      $('#project_draft_governance_system').summernote('codeview.deactivate');
    }
  }
  @on('change #project_draft_is_framed')
  onChangeIsFramed() {
    this.render();
  }

  render() {
    const url = 'https://www.googleapis.com/youtube/v3/videos';
    const videoId = 'id=' + this.movie;
    const apiKey = 'key=AIzaSyDryFcx597-RtHbDCL8XIazSJEdbnly4r8'; // TODO
    const part = 'part=snippet';
    const angelType = parseInt(
      $('input[name="project_draft[angel_type]"]')
        .filter(':checked')
        .val(),
    );
    const contractBeforeType = parseInt(
      $('input[name="project_draft[contract_before_type]"]')
        .filter(':checked')
        .val(),
    );
    const stockType = parseInt(
      $('input[name="project_draft[stock_type]"]')
        .filter(':checked')
        .val(),
    );
    const isFramed = $('#project_draft_is_framed').prop('checked');

    if (this.image !== '') {
      $('#preview_image')
        .css('background-image', `url(${this.image})`)
        .show();
    }

    if (this.presidentImage !== '') {
      $('#preview_president_image')
        .css('background-image', `url(${this.presidentImage})`)
        .show();
    }

    if (this.stamp !== '') {
      $('#preview_stamp')
        .css('background-image', `url(${this.stamp})`)
        .show();
    }

    $.get(`${url}?${apiKey}&${videoId}&${part}`, response => {
      if (response.pageInfo.totalResults == 0) {
        $('#youtube').hide();
      } else {
        $('#youtube').show();
      }
    });

    $('#youtube').attr('src', '//www.youtube.com/embed/' + this.movie);

    if (angelType === 0) {
      $('#angel_properties').hide();
    } else {
      $('#angel_properties').show();
    }

    if (contractBeforeType === 0) {
      $('.project_draft_contract_before').show();
      $('#contract_info').hide();
      $('.project_draft_company_info').show();
      $('.project_draft_solicit_info').show();
      $('.project_draft_review_result').show();
    } else {
      $('.project_draft_contract_before').hide();
      $('#contract_info').show();
      $('.project_draft_company_info').hide();
      $('.project_draft_solicit_info').hide();
      $('.project_draft_review_result').hide();
    }

    if (isFramed) {
      $('#board_meeting_info').show();
    } else {
      $('#board_meeting_info').hide();
    }

    if (stockType === 0) {
      $('.project_draft_deliv_start_on').hide();
      $('.project_draft_deliv_start_changed_on').hide();
      $('.project_draft_stock_price_for_reserve').show();
      $('.project_draft_stock_price label').html('1株あたりの価格（円）');
      $('.project_draft_deliv_end_on label').html('払込期日');
      $('.project_draft_deliv_end_changed_on label').html('変更後の払込期日');
      $('.project_draft_law_notification label').html(
        '会社法203条1項及び会社法施行規則42条に基づく通知',
      );
      $('.project_draft_transfer_restriction label').html(
        '募集株式の譲渡制限（金融商品取引契約の概要・事業者情報・募集事項の内容等の12）',
      );
    } else {
      $('.project_draft_deliv_start_on').hide();
      $('.project_draft_deliv_start_changed_on').hide();
      $('.project_draft_stock_price_for_reserve').hide();
      $('.project_draft_stock_price label').html('1個あたりの価格（円）');
      $('.project_draft_deliv_end_on label').html('払込期日');
      $('.project_draft_deliv_end_changed_on label').html('変更後の払込期日');
      $('.project_draft_law_notification label').html(
        '会社法242条及び会社法施行規則54条に基づく通知',
      );
      $('.project_draft_transfer_restriction label').html(
        '新株予約権の譲渡制限（金融商品取引契約の概要・事業者情報・募集事項の内容等の12）',
      );
    }
  }
}
